import { render, staticRenderFns } from "./LinkArrow.vue?vue&type=template&id=723fd166&"
import script from "./LinkArrow.vue?vue&type=script&lang=js&"
export * from "./LinkArrow.vue?vue&type=script&lang=js&"
import style0 from "./LinkArrow.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports